import axios from 'axios';
import baseURL from './configRoutes.js';
import { toast } from 'react-toastify';
import { assertPayloadWithinLimits, assertQueryWithinLimit } from '../utils/requestLimits';
import { sanitizePayload, sanitizeQueryString } from '../utils/inputSanitizer';

import { userLoggedOut } from "../redux/auth/authSlice";
const LOGIN_GUARD_MS = 30 * 1000;
const LOGIN_ENDPOINTS = new Set([
  "admin-login",
  "school-login",
  "faculty-login",
  "faculty-login-password",
  "get-otp",
  "get-faculty-otp",
]);

const handleLogout = async (dispatch) => {
   try {
     await fetch(
       `https://ecoclubs.education.gov.in/api/logout`,
       {
         method: "GET",
         headers: {
           "Content-Type": "application/json",
         },
         credentials: "include",
       }
     );
   } catch (error) {
     toast.error("Logout Failed");
     console.log(error);
   }
   dispatch(userLoggedOut());
 };

 export default async function axiosConn(method, url, data, header, dispatch) {
   try {
    const sanitizedUrl = sanitizeQueryString(baseURL.baseURL + url);
    const isFormData = data instanceof FormData;
    
    // Don't sanitize FormData - pass it through unchanged
    const sanitizedData = isFormData ? data : sanitizePayload(data);
    assertQueryWithinLimit(sanitizedUrl);
    assertPayloadWithinLimits(sanitizedData);
    
    // Build headers - CRITICAL: don't override FormData content-type, but keep custom headers
    const finalHeader = header ? { ...header } : {};
    
    // If FormData, remove any manual Content-Type so axios auto-detects
    if (isFormData) {
      console.log('📤 Sending FormData:', { 
        url: sanitizedUrl,
        method: method,
        isFormData: true,
        headerKeys: Object.keys(finalHeader)
      });
      delete finalHeader['Content-Type'];
      delete finalHeader['content-type'];
    } else {
      console.log('📤 Sending JSON data:', { url: sanitizedUrl, method: method });
    }
    
    const axiosConfig = {
      url: sanitizedUrl,
      method: method,
      data: sanitizedData,
      timeout: LOGIN_ENDPOINTS.has(url) ? LOGIN_GUARD_MS : 0,
      withCredentials: true,
    };

    if (Object.keys(finalHeader).length > 0) {
      axiosConfig.headers = finalHeader;
    }
    
    const response = await axios(axiosConfig);
    console.log('✅ Response:', response.status, response.data);

    return response;
   } catch (error) {
      if (LOGIN_ENDPOINTS.has(url) && (error.code === "ECONNABORTED" || String(error.message || "").toLowerCase().includes("timeout"))) {
      toast.error("Login request timed out. Please try again.");
      }
      // 409 SESSION_IDENTITY_MISMATCH: the cookie belongs to a different school
      // than the one this tab is showing (another tab logged in). Nothing was
      // saved server-side. Tell the user and reload so the tab re-reads /me.
      if (error.response?.status === 409 && error.response?.data?.code === "SESSION_IDENTITY_MISMATCH") {
        toast.error(error.response.data.message || "This browser is now logged in as a different school. Reloading…", { autoClose: 6000 });
        setTimeout(() => window.location.reload(), 3000);
      }
      // Handle the case where the error status is 401
      if (error.response?.status === 401 || (error.response?.status === 400 && ["Please login to access this resource!", "Please login for access this resources!"].includes(error.response?.data?.message))) {
        const message = error.response?.data?.message || "Session expired. Please login again.";
         toast.error(message);
         

         // Call the handleLogout function to log the user out
         if (dispatch) {
            handleLogout(dispatch);
         }
      }

      console.error('Error during request:', error);
      throw error;  // Re-throw error if needed
   }
}
